import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import PstnSettingsForm from '../forms/PstnSettingsForm'
import globals from '../globals'

class PstnSettings extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            settings: {}
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getPstnSettings/${this.props.serviceId}`, result => {
            this.setState({
                settings: result.settings,
                isLoaded: true
            })
        })
    }

    render () {
        return (
            <div className='voip-settings module'>
                <Heading title='Call & voicemail settings' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>You can manage your Home Phone (PSTN) service call features here. Simply make your selections and hit the “Update settings” button. Once you’ve saved your choices, we’ll send you an email to confirm your settings and save them here for next time you visit.</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <PstnSettingsForm
                                fields={this.state.settings}
                                serviceId={this.props.serviceId}
                                handleSuccess={() => globals.pushEvent('ChangePstnSettingsSubmit')}
                            />
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default PstnSettings



// WEBPACK FOOTER //
// ./resources/js/modules/PstnSettings.js